export default __webpack_public_path__ + "static/media/bump_logo.b5076d37.webp";